<template>
  <div class="tracking-network-view">
    <router-view />

    <layout-logged-frame
      :back-url="backUrl"
      :title="activeNetwork.name"
      >
      <template #header-actions>
        <v-btn
          color="primary"
          @click="openNewCredentialsModal"
        >
          <v-icon>add</v-icon>
          {{ $t('new_credentials') }}
        </v-btn>
      </template>

      <template #content>
        <v-card
          class="elevation-0"
          :loading="isLoading"
        >
          <panels-tracking-network :network="activeNetwork" />
        </v-card>

        <table-tracking-credentials :network="activeNetwork" />
      </template>
    </layout-logged-frame>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isLoading: false,
        backUrl: '/tracking-networks',
      };
    },
    computed: {
      activeNetwork() {
        return this.$store.getters['tracking/activeTrafficNetwork'] || {};
      },
    },
    created() {
      this.getNetwork(this.$route.params.id);
    },
    methods: {
      getNetwork(id) {
        this.isLoading = true;
        this.$store.dispatch('tracking/getTrafficNetwork', id)
          .catch((err) => err)
          .finally(() => {
            this.isLoading = false;
          });
      },
      openNewCredentialsModal() {
        this.$router.push({ name: 'tracking-networks-new-credentials' });
      },
    },
  };
</script>
